// mapa de domínio → ícone
const domainIconMap: Record<string, { icon: string }> = {
  'trisolution.com.br': { icon: '/48762505000110.svg' },
  // 'mdtributaria.com.br': { icon: '/46553339000116.svg' },
  // 'grupobahiasul.com.br': { icon: '/46151037000111.svg' },
  'dsconsultoriat.com.br': { icon: '/59754843000126.svg' }
}

// ícone padrão se não encontrar
const defaultIcon = '/50734366000162.svg'

/**
 * Retorna o ícone correspondente ao domínio.
 * @param domain domínio já limpo (ex: "trisolution.com.br")
 * @returns caminho do ícone
 */
export function getDomainIcon(domain: string | null | undefined): string {
  if (!domain) return defaultIcon
  return domainIconMap[domain]?.icon || defaultIcon
}
